<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

    <!--列表-->
    <el-table :data="Users" border v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow"
      ref="table" class="custom-tbl" style="width: 100%">
      <el-table-column type="selection" width="50"> </el-table-column>
      <el-table-column type="index" width="50"> </el-table-column>
      <el-table-column prop="Name" label="机构名称" width="160" sortable>
      </el-table-column>
      <el-table-column prop="OrganCode" label="机构编码" width="130" sortable>
      </el-table-column>
      <el-table-column prop="ParentName" label="上级机构名称" width="160" sortable>
      </el-table-column>
      <el-table-column prop="Content" label="机构简介" width="200" sortable>
      </el-table-column>
      <el-table-column prop="ConUser" label="联系人" width="100" sortable>
      </el-table-column>
      <el-table-column prop="ConUserTel" label="联系电话" width="150" sortable>
      </el-table-column>
      <el-table-column prop="TypeName" label="机构类型名称" width="150" :formatter="formType" sortable>
      </el-table-column>
      <el-table-column prop=" Grade" label="机构等级名称" width="150" :formatter="formaGrade" sortable>
      </el-table-column>
      <el-table-column prop="Level" label="机构级别名称" width="150" :formatter="formaLeavel" sortable>
      </el-table-column>
      <el-table-column prop="CreateTime" label="创建时间" width="160" sortable>
      </el-table-column>
      <el-table-column prop="CreateBy" label="创建人" width="100" sortable>
      </el-table-column>
      <el-table-column prop="IsEnable" label="状态" width="" sortable>
        <template slot-scope="scope">
          <el-tag :type="scope.row.IsEnable == 1 ? 'success' : 'danger'" disable-transitions>{{ scope.row.IsEnable == 1
      ?
      "正常" : "禁用" }}
          </el-tag>
        </template>
      </el-table-column>

    </el-table>

    <!--工具条-->
    <!-- <el-col :span="24" class="toolbar">
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="50" :total="total"
        style="float: right">
      </el-pagination>
    </el-col> -->
    <el-pagination class="toolbar" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="page" :page-size="pageSize" :page-sizes="[50, 100, 200]"
      layout="total, sizes, prev, pager, next, jumper" :total="total">
    </el-pagination>

    <el-dialog title="新增" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false">
      <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
        <el-form-item label="机构名称" prop="Name">
          <el-input v-model="addForm.Name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="机构编码" prop="OrganCode">
          <el-input v-model="addForm.OrganCode" auto-complete="off"></el-input>
        </el-form-item>
        <!-- <el-form-item label="上级机构" prop="orgList" label-width="100">
          <el-select v-model="addForm.orgList" filterable placeholder="上级机构" @change="handleOrgChange">
            <el-option v-for="item in orgList" :key="item.Id" :label="item.Name" :value="item.Id">
            </el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item label="上级机构" prop="orgList" label-width="">
          <el-select v-model="addForm.orgList" filterable placeholder="" @change="handleOrgChange" clearable>
            <el-option v-for="item in orgList" :key="item.Id" :label="item.Name" :value="item.Id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="机构简介" prop="Content">
          <el-input v-model="addForm.Content" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="ConUser">
          <el-input v-model="addForm.ConUser" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="ConUserTel">
          <el-input v-model="addForm.ConUserTel" auto-complete="off"></el-input>
          <el-form-item :rules="phoneRules" prop="ConUserTel"></el-form-item>
        </el-form-item>

        <el-form-item>
          <el-col :span="8">
            <el-form-item prop="TypeId">
              <el-select v-model="addForm.TypeId" placeholder="机构类型">
                <el-option label="市级医院" value="1"></el-option>
                <el-option label="县级医院" value="2"></el-option>
                <el-option label="卫生院" value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="Grade">
              <el-select v-model="addForm.Grade" placeholder="机构等级">
                <el-option label="甲等" value="1"></el-option>
                <el-option label="乙等" value="2"></el-option>
                <el-option label="丙等" value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item prop="Level">
              <el-select v-model="addForm.Level" placeholder="机构级别">
                <el-option label="一级" value="1"></el-option>
                <el-option label="二级" value="2"></el-option>
                <el-option label="三级" value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="状态" prop="IsEnable">
          <el-select v-model="addForm.IsEnable" placeholder="请选择机构状态">
            <el-option label="激活" :value="true"></el-option>
            <el-option label="禁用" :value="false"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelSubmit" @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog title="编辑" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false">
      <el-form :model="editForm" label-width="80px" ref="editForm" :rules="editRules">
        <el-form-item label="机构名称" prop="Name">
          <el-input v-model="editForm.Name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="机构编码" prop="OrganCode">
          <el-input v-model="editForm.OrganCode" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="机构简介" prop="Content">
          <el-input v-model="editForm.Content" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="ConUser">
          <el-input v-model="editForm.ConUser" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="ConUserTel">
          <el-input v-model="editForm.ConUserTel" auto-complete="off"></el-input>
          <el-form-item :rules="phoneRules" prop="ConUserTel"></el-form-item>
        </el-form-item>
        <el-form-item>
          <el-col :span="8">
            <el-select v-model="editForm.TypeId" placeholder="请选择机构类型">
              <el-option label="市级医院" :value="1"></el-option>
              <el-option label="县级医院" :value="2"></el-option>
              <el-option label="卫生院" :value="3"></el-option>
            </el-select>
          </el-col>
          <el-col :span="8">
            <el-select v-model="editForm.Grade" placeholder="请选择机构等级">
              <el-option label="甲等" :value="1"></el-option>
              <el-option label="乙等" :value="2"></el-option>
              <el-option label="丙等" :value="3"></el-option>
            </el-select>
          </el-col>
          <el-select v-model="editForm.Level" placeholder="请选择机构级别">
            <el-option label="一级" :value="1"></el-option>
            <el-option label="二级" :value="2"></el-option>
            <el-option label="三级" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="IsEnable">
          <el-select v-model="editForm.IsEnable" placeholder="请选择角色状态">
            <el-option v-for="item in statusList" :key="item.value" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>

  </section>
</template>

<script>
import util from "../../../util/date";
import {
  getMedicalListPage,
  addMedical,
  GetMediOpion,
  RemoveMedical,
  editMedical,
  Getmedcialbyid,
} from "../../api/Medicalorganization/Medicalorganization";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import { completeDimensions } from "echarts/lib/helper";
export default {
  components: { Toolbar },
  data () {
    return {
      filters: {
        name: "",
      },
      statusList: [
        { name: "激活", value: true },
        { name: "禁用", value: false },
      ],
      orgList: [],
      parentname: "",
      Name: "",
      Users: [],
      total: 0,
      buttonList: [],
      currentRow: null,
      page: 1,
      pageSize: 50,
      listLoading: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      sels: [], //列表选中列
      phoneRules: [
        { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的电话号码', trigger: 'blur' }
      ],
      addDialogFormVisible: false,
      isResouceShow: 0,
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      IsEnable: true,
      addFormRules: {
        Name: [{ required: true, message: "请输入机构名称", trigger: "blur" }],
        OrganCode: [{ required: true, message: "请输入机构编码", trigger: "blur" }],
        Level: [{ required: true, message: "请输入机构级别", trigger: "change" }],
        TypeId: [{ required: true, message: "请输入机构类型", trigger: "change" }],
        Grade: [{ required: true, message: "请输入机构等级", trigger: "change" }]
      },
      editRules: {
        Name: [{ required: true, message: "请输入机构名称", trigger: "blur" }],
        OrganCode: [{ required: true, message: "请输入机构编码", trigger: "blur" }],
        Level: [{ required: true, message: "请输入机构级别", trigger: "change" }],
        TypeId: [{ required: true, message: "请输入机构类型", trigger: "change" }],
        Grade: [{ required: true, message: "请输入机构等级", trigger: "change" }]
      },

      //新增界面数据
      addForm: {
        orgList: [],
        Name: "",
        OrganCode: "",
        Content: "",
        ConUser: "",
        ConUserTel: "",
        TypeId: "",
        TypeName: "",
        OrderSort: 0,
        IsEnable: "",
        Level: "",
        Grade: "",
        ParentId: 0,
        ParentName: "" //用于存储选中的 label
      },
      editForm: {
        Id: "",
        Name: "",
        OrganCode: "",
        Content: "",
        ConUser: "",
        ConUserTel: "",
        TypeId: "",
        TypeName: "",
        IsEnable: "",
        Level: "",
        Grade: "",
        ParentId: "",
        OrderSort: 0,
        editmedical: [],
        parentname: "",
      },
    };
  },
  computed: {
    gradeText () {
      const grades = {
        1: '甲等',
        2: '乙等',
        3: '丙等'
      };
      return grades[this.editForm.Grade];
    },
    levelText () {
      const levels = {
        1: '一级',
        2: '二级',
        3: '三级'
      };
      return levels[this.editForm.Level];
    },
    TypelText () {
      const Types = {
        1: '市级医院',
        2: '县级医院',
        3: '卫生院'
      };
      return Types[this.editForm.TypeId];
    },
  },
  methods: {
    dialogCheck (selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    callFunction (item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    selectCurrentRow (val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(
          new Date(row.CreateTime),
          "yyyy-MM-dd hh:mm:ss"
        );
    },
    formatModifyTime: function (row, column) {
      return !row.ModifyTime || row.ModifyTime == ""
        ? ""
        : util.formatDate.format(
          new Date(row.ModifyTime),
          "yyyy-MM-dd hh:mm:ss"
        );
    },
    handleCurrentChange (val) {
      this.page = val;
      this.Getmedical();
    },
    handleSizeChange (size) {
      this.pageSize = size;
      this.page = 1; // 当更改分页大小时，重置为第一页
      this.Getmedical();

    },
    handleOrgChange (value) {
      const selectedOrg = this.orgList.find(item => item.Id === value);
      if (selectedOrg) {
        this.addForm.ParentId = selectedOrg.Id;
        this.addForm.ParentName = selectedOrg.Name;
      }
    },

    //获取机构信息
    Getmedical () {
      let para = {
        page: this.page,
        key: this.filters.name,
        PageSize: this.pageSize,
      };
      this.listLoading = true;
      getMedicalListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.Users = res.data.response.data;
        this.listLoading = false;
        //NProgress.done();
      });
    },
    GetMediOption () {
      GetMediOpion().then((res) => {
        this.orgList = res.data.response;
      });
    },
    Getmedicalname () {
      let para = {
        id: this.editForm.ParentId.toString(),
      };
      Getmedcialbyid(para).then((res) => {
        this.editForm.editmedical = res.data.response;
        this.editForm.parentname = res.data.response.Name;
      });
    },
    //显示新增界面
    handleAdd () {
      this.GetMediOption();
      this.addFormVisible = true;
      this.addForm = {
        orgList: [],
        Name: "",
        OrganCode: "",
        Content: "",
        ConUser: "",
        ConUserTel: "",
        TypeId: null,
        TypeName: "",
        OrderSort: 0,
        IsEnable: true,
        Level: null,
        Grade: null,
        ParentId: 0,
        ParentName: "",
      };
    },
    handleEdit () {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });
        return;
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
      if (this.editForm.ParentId > 0) {
        this.Getmedicalname();
      }
    },
    //新增
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);
            addMedical(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              this.addLoading = false;
              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.Getmedical();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    formaGrade (row, column) {
      const Grade = row.Grade;
      switch (Grade) {
        case 1:
          return "甲等";
        case 2:
          return "乙等";
        case 3:
          return "丙等";
      }
    },
    formaLeavel (row, column) {
      const Level = row.Level;
      switch (Level) {
        case 1:
          return "一级";
        case 2:
          return "二级";
        case 3:
          return "三级";
      }
    },
    formType (row, column) {
      const type = row.TypeId;
      switch (type) {
        case 1:
          return "市级医院";
        case 2:
          return "县级医院";
        case 3:
          return "卫生院";
      }
    },
    //删除
    handleDel () {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.Id };
          RemoveMedical(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.currentRow = null; // Clear current row selection
              this.Getmedical(); //
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

          });
        })
        .catch(() => { });
    },
    editSubmit: function () {
      //保存
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);
            editMedical(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.currentRow = null; // Clear current row selection
                this.editFormVisible = false;
                this.Getmedical();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    //添加点击取消
    cancelSubmit () {
      console.log("取消");
      this.$refs["addForm"].resetFields();
      this.addFormVisible = false;
    }
  },
  mounted () {
    this.Getmedical();
    //this.GetMediOption();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },


  watch: {
    'addForm.TypeId': function (newVal) {
      // 根据不同的机构类型，更新其他属性值
      switch (newVal) {
        case '1':
          this.addForm.TypeName = '市级医院';

          break;
        case '2':
          this.addForm.TypeName = '县级医院';

          break;
        case '3':
          this.addForm.TypeName = '卫生院';
          break;
        default:
          this.addForm.TypeName = ''; // 可以根据实际需求设置默认值或其他处理
          this.addForm.TypeName = '';
          break;
      }
    },
    'editForm.Typeid': function (newVal) {
      switch (newVal) {
        case '1':
          this.editForm.TypeName = '市级医院';

          break;
        case '2':
          this.editForm.TypeName = '县级医院';

          break;
        case '3':
          this.editForm.TypeName = '卫生院';
          break;
        default:
          this.editForm.TypeName = ''; // 可以根据实际需求设置默认值或其他处理
          break;
      };
    },

  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
</style>
